import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateTask as CreateTaskMutation,
    CreateTaskVariables,
    TaskCreateInput,
} from 'nutshell-graphql-types';

import CREATE_TASK from '../mutations/create-task.graphql';

interface CreateTaskOptions {
    refetchQueries: any[];
}

export const useCreateTask = (
    options?: CreateTaskOptions
): {
    createTask: (arg1: TaskCreateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createTask, {loading, error}] = useMutation<CreateTaskMutation, CreateTaskVariables>(
        CREATE_TASK
    );

    return {
        createTask: (input: TaskCreateInput) => {
            return createTask({
                variables: {input},
                refetchQueries: options?.refetchQueries,
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
